import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';
import { ClassGradebookQuery } from './useClassGradebookQuery';

const CreateAssignmentMutation = graphql.persisted(
  "CreateAssignment",
  graphql(`
    mutation CreateAssignment($input: CreateAssignmentInput!) {
      createAssignment(input: $input) {
        assignment {
          id name description pointsPossible dueOn position
          targets {
            id
            gradebook { id name }
            gradebookCategory { id name }
          }
        }
        userErrors { message path }
      }
    }
  `)
);

const UpdateAssignmentMutation = graphql.persisted(
  "UpdateAssignment",
  graphql(`
    mutation UpdateAssignment($input: UpdateAssignmentInput!) {
      updateAssignment(input: $input) {
        assignment {
          id name description pointsPossible dueOn position
          targets {
            id
            gradebook { id name }
            gradebookCategory { id name }
          }
        }
        userErrors { message path }
      }
    }
  `)
);

const DeleteAssignmentMutation = graphql.persisted(
  "DeleteAssignment",
  graphql(`
    mutation DeleteAssignment($input: DeleteAssignmentInput!) {
      deleteAssignment(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

const SaveAssignmentScoresMutation = graphql.persisted(
  "SaveAssignmentScores",
  graphql(`
    mutation SaveAssignmentScores($input: SaveAssignmentScoresInput!) {
      saveAssignmentScores(input: $input) {
        assignment {
          id
          scores {
            id state pointsEarned comment lockVersion
            person { id firstName lastName }
          }
        }
        userErrors { message path }
      }
    }
  `)
);

const SetAssignmentPostedMutation = graphql.persisted(
  "SetAssignmentPosted",
  graphql(`
    mutation SetAssignmentPosted($input: SetAssignmentPostedInput!) {
      setAssignmentPosted(input: $input) {
        assignment { id posted postedAt }
        userErrors { message path }
      }
    }
  `)
);

export {
  CreateAssignmentMutation,
  UpdateAssignmentMutation,
  DeleteAssignmentMutation,
  SaveAssignmentScoresMutation,
  SetAssignmentPostedMutation,
};

const refreshGradebook = {
  refetchQueries: [ClassGradebookQuery],
  awaitRefetchQueries: true,
};

export function useCreateAssignment() { return useMutation(CreateAssignmentMutation, refreshGradebook); }
export function useUpdateAssignment() { return useMutation(UpdateAssignmentMutation, refreshGradebook); }
export function useDeleteAssignment() { return useMutation(DeleteAssignmentMutation, refreshGradebook); }
export function useSaveAssignmentScores() { return useMutation(SaveAssignmentScoresMutation, refreshGradebook); }
export function useSetAssignmentPosted() { return useMutation(SetAssignmentPostedMutation, refreshGradebook); }
